import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../Services/auth.service';
import { NotificationService } from '../../../Services/notification.service';
import { CustomSelectComponent } from '../../Core/custom-select/custom-select.component';

@Component({
  selector: 'app-send-otp',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink, CustomSelectComponent],
  templateUrl: './send-otp.component.html',
  styleUrls: ['./send-otp.component.css']
})
export class SendOtpComponent {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);

  UserType: string[] = ['Staff', 'Owner'];
  isLoading: boolean = false;

  otpForm: FormGroup = this.fb.group({
    user_type: ['', [Validators.required]],
    mobilenumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
  });

  get f() {
    return this.otpForm.controls;
  }

  sendOtp() {
    if (this.otpForm.invalid) {
      this.otpForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const payload = this.otpForm.value;

    this.authService.sendOtpLogin(payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res.success) {
          this.notificationService.showSuccess(res.message || 'OTP sent successfully!', 'Success');
          this.router.navigate(['validate-otp'], {
            state: {
              user_type: payload.user_type,
              mobilenumber: payload.mobilenumber
            }
          });
        } else {
          this.notificationService.showError(res.message || 'Failed to send OTP', 'Error');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error:', err);
        this.notificationService.showError(err.error?.message || 'Something went wrong, please try again.', 'Error');
      }
    });
  }
}
